import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import Complaint from '../views/Complaint.vue'
 
//解决  NavigationDuplicated: Avoided redundant navigation to current location: 报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
 

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [ 
    {
      path: '/',
      name: 'Home',
      component: Home
    },
	{
	  path: '/baseDepartList',
	  name: 'BaseDepartList',
	 component: () => import(/* webpackChunkName: "about" */ '../components/common/BaseDepartList.vue')
	},
	{
	  path: '/baseMenuList',
	  name: 'BaseMenuList',
	 component: () => import(/* webpackChunkName: "about" */ '../components/common/BaseMenuList.vue')
	},
	{
	  path: '/baseRole',
	  name: 'BaseRole',
	 component: () => import(/* webpackChunkName: "about" */ '../components/common/BaseRole.vue')
	},
	{
	  path: '/baseUser',
	  name: 'BaseUser',
	 component: () => import(/* webpackChunkName: "about" */ '../components/common/BaseUser.vue')
	},
	{
	  path: '/baseDictList',
	  name: 'BaseDictList',
	 component: () => import(/* webpackChunkName: "about" */ '../components/common/BaseDictList.vue')
	},
	{
	  path: '/baseLocationList',
	  name: 'BaseLocationList',
	 component: () => import(/* webpackChunkName: "about" */ '../components/common/BaseLocationList.vue')
	},
	{
	  path: '/baseLocationRoleList',
	  name: 'BaseLocationRoleList',
	 component: () => import(/* webpackChunkName: "about" */ '../components/common/BaseLocationRoleList.vue')
	},
	{
	  path: '/baseHome',
	  name: 'BaseHome',
	 component: () => import(/* webpackChunkName: "about" */ '../components/common/BaseHome.vue')
	},
	{
	  path: '/baseHomeDetail',
	  name: 'BaseHomeDetail',
	 component: () => import(/* webpackChunkName: "about" */ '../components/common/BaseHomeDetail.vue')
	},
	
	//------------以上是基础框架-----------------
	{
	  path: '/complaint',
	  name: 'Complaint',
	  component: Complaint
	},
	{
	  path: '/messageList',
	  name: 'MessageList',
	 component: () => import(/* webpackChunkName: "about" */ '../views/messageList.vue')
	},
    {
      path: '/normalUserRegiser',
      name: 'normalUserRegiser',
      component: () => import(/* webpackChunkName: "about" */ '../views/NormalUserRegiser.vue')
    },
	{
	  path: '/login',
	  name: 'login',
	  component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
	},
	{
	  path: '/pictureUpload',
	  name: 'pictureUpload',
	  component: () => import(/* webpackChunkName: "about" */ '../views/PictureUpload.vue')
	},
	{
	  path: '/resourceDisplay',
	  name: 'resourceDisplay',
	  component: () => import(/* webpackChunkName: "about" */ '../views/resource/ResourceDisplay.vue')
	},
	{
	  path: '/resourceDownload',
	  name: 'resourceDownload',
	  component: () => import(/* webpackChunkName: "about" */ '../views/resource/ResourceDownload.vue')
	},
	{
	  path: '/adminComplaintListDo',
	  name: 'adminComplaintListDo',
	  component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminComplaintListDo.vue')
	},
	{
	  path: '/adminComplaintListUnDo',
	  name: 'adminComplaintListUnDo',
	  component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminComplaintListUnDo.vue')
	},
	{
	  path: '/complaintSendDo',
	  name: 'complaintSendDo',
	  component: () => import(/* webpackChunkName: "about" */ '../views/complaint/ComplaintSendDo.vue')
	},
	{
	  path: '/adminBzReadyResourceList',
	  name: 'adminBzReadyResourceList',
	  component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminBzReadyResourceList.vue')
	},
	{
	  path: '/adminBzAuditResourceList',
	  name: 'adminBzAuditResourceList',
	  component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminBzAuditResourceList.vue')
	},
	{
	  path: '/userInfoList',
	  name: 'userInfoList',
	  component: () => import(/* webpackChunkName: "about" */ '../views/admin/UserInfoList.vue')
	},
	{
	  path: '/readyDeveloperList',
	  name: 'readyDeveloperList',
	  component: () => import(/* webpackChunkName: "about" */ '../views/admin/ReadyDeveloperList.vue')
	},
	{
	  path: '/readyBlokerList',
	  name: 'readyBlokerList',
	  component: () => import(/* webpackChunkName: "about" */ '../views/admin/ReadyBlokerList.vue')
	},
	{
	  path: '/toDevUser',
	  name: 'toDevUser',
	  component: () => import(/* webpackChunkName: "about" */ '../views/toDeveloper/ToDevUser.vue')
	},
	{
	  path: '/toBlockUser',
	  name: 'toBlockUser',
	  component: () => import(/* webpackChunkName: "about" */ '../views/toBlocker/ToBlockUser.vue')
	},
	{
	  path: '/contactUs',
	  name: 'contactUs',
	  component: () => import(/* webpackChunkName: "about" */ '../views/ContactUs.vue')
	},
	{
	  path: '/ruleDes',
	  name: 'ruleDes',
	  component: () => import(/* webpackChunkName: "about" */ '../views/RuleDes.vue')
	},
	{
	  path: '/complaintSend',
	  name: 'complaintSend',
	  component: () => import(/* webpackChunkName: "about" */ '../views/complaint/ComplaintSend.vue')
	},
	
	
	// {
	//   path: '/resourceDownloadShow',
	//   name: 'resourceDownloadShow',
	//   component: () => import(/* webpackChunkName: "about" */ '../views/ResourceDownloadShow.vue')
	// },
	// {
	//   path: '/pointChangeShow',
	//   name: 'pointChangeShow',
	//   component: () => import(/* webpackChunkName: "about" */ '../views/PointChangeShow.vue')
	// },
	{
	  path: '/myProfile',
	  name: 'myProfile',
	  component: () => import(/* webpackChunkName: "about" */ '../views/MyProfile.vue'),
	  children: [{
	                  path: 'userInfo',
	                  component: () => import('../views/my/UserInfo.vue')
	              },
	              {
	                  path: 'resourceBuyReocrdShow',
	                  component: () => import('../views/ResourceBuyReocrdShow.vue')
	              } ,
	              {
	                  path: 'resourceList',
	                  component: () => import('../views/my/ResourceList.vue')
	              } ,
				  {
				      path: 'userPoint',
				      component: () => import('../views/my/UserPoint.vue')
				  } ,
				  {
				      path: 'pointWaitSale',
				      component: () => import('../views/my/PointWaitSale.vue')
				  } ,
				  {
				      path: 'pointSaledt',
				      component: () => import('../views/my/PointSaledt.vue')
				  } ,
				  {
				      path: 'passwordChange',
				      component: () => import('../views/my/PasswordChange.vue')
				  } ,
	          ]
	}, 
	{
	  path: '/adminPointInfoList',
	  name: 'adminPointInfoList',
	  component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminPointInfoList.vue')
	},
	{
	  path: '/adminUserPointRecord',
	  name: 'adminUserPointRecord',
	  component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminUserPointRecord.vue')
	},
	{
	  path: '/adminPointBuyRecord',
	  name: 'adminPointBuyRecord',
	  component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminPointBuyRecord.vue')
	},
	{
	  path: '/adminPointWaitSalet',
	  name: 'adminPointWaitSalet',
	  component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminPointWaitSalet.vue')
	},
	{
	  path: '/adminPointSaledt',
	  name: 'adminPointSaledt',
	  component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminPointSaledt.vue')
	},
	{
	  path: '/adminAllNotice',
	  name: 'adminAllNotice',
	  component: () => import(/* webpackChunkName: "about" */ '../views/admin/AdminAllNotice.vue')
	},
	{
	  path: '/baiDuNetDisk',
	  name: 'baiDuNetDisk',
	  component: () => import(/* webpackChunkName: "about" */ '../views/admin/BaiDuNetDisk.vue')
	},
  ]
})
